<template>
  <v-container class="tag-cloud pt-3 pb-0" v-if="filterTagsByCount.length">
    <h4 class="title grey--text text--darken-1 pt-3 pb-3">
      <router-link
        class="grey--text text--darken-1"
        v-html="$store.getters.getLangKey('tags')"
        to="/tag" />
    </h4>
    <ol class="inside-list bulletless-list">
      <li v-for="(tag, index) in filterTagsByCount" :key="index">
        <router-link :to="`/tag/${tag.slug}`" :style="{'font-size': tagSize(tag.post_count)}">{{ tag.title }}</router-link>
      </li>
    </ol>
  </v-container>
</template>
<script>
  export default {
    name: 'TagCloud',
    data () {
      return {
        tags: this.$store.state.bootstrapData.tags || [],
        minCount: this.$attrs['min-count'] || 0
      }
    },
    computed: {
      filterTagsByCount () {
        return this.tags.filter(tag => tag.post_count > this.minCount)
      }
    },
    methods: {
      /**
       * Calculate the tag size
       * @method tagSize
       * @param {Number} count
       * @return {Number|String}
       * **/
      tagSize (count) {
        return count < 9 ? 'inherit' : count + 'px'
      }
    }
  }
</script>
<style>
.tag-cloud li
{
  display: inline-block;
  margin: 0 .1em 0;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/TagCloud.vue